import './styles/themes.css';
import './styles/base.css';
import './styles/editor.css';
import './styles/discord.css';
import { DEMO, api, setTransport } from './api.js';
import { app } from './ctx.js';
import { h, icon } from './dom.js';
import { editorPage } from './editor/index.js';
import { navigate, route, startRouter } from './router.js';
import { guildsPage, loginPage, settingsPage } from './views/pages.js';
import { toast } from './ui/overlay.js';
import { currentTheme, initTheme } from './theme.js';

const root = document.getElementById('app')!;

function loading() {
  root.replaceChildren(h('div', { class: 'center-page' }, h('div', { class: 'loader' }, icon('sparkles', 28))));
}

async function ensureGuild(id: string): Promise<boolean> {
  if (app.guild?.id === id) return true;
  loading();
  try {
    app.guild = await api.guild(id);
    document.title = `${app.guild.name} · Embed Studio`;
    return true;
  } catch (err: any) {
    toast(err.message, 'error');
    navigate('#/');
    return false;
  }
}

async function boot() {
  initTheme();
  // предпросмотр Discord по умолчанию в тон панели
  app.previewTheme = currentTheme().light ? 'light' : 'dark';
  if (DEMO) {
    const { mockTransport } = await import('./mock.js');
    setTransport(mockTransport);
  }
  loading();
  try {
    app.me = await api.me();
  } catch {
    app.me = { user: null, oauth: false, inviteUrl: null, ready: false };
  }

  route('/login', (_p, q) => loginPage(root, q));
  route('/', () => (app.me?.user ? guildsPage(root) : loginPage(root, new URLSearchParams())));
  route('/g/:id/editor', async (p, q) => {
    if (!app.me?.user) return navigate('#/login');
    if (await ensureGuild(p.id)) await editorPage(root, q);
  });
  route('/g/:id/settings', async (p) => {
    if (!app.me?.user) return navigate('#/login');
    if (await ensureGuild(p.id)) settingsPage(root);
  });
  route('/g/:id', (p) => navigate(`#/g/${p.id}/editor`));

  startRouter();
}

document.body.prepend(h('div', { class: 'bg-scene', attrs: { 'aria-hidden': 'true' } }, h('span', { class: 'blob b1' }), h('span', { class: 'blob b2' }), h('span', { class: 'blob b3' }), h('span', { class: 'noise' })));
boot();
